module.exports = __webpack_public_path__ + "img/clock.08c391f5.svg";